import { Button, Flex, Tooltip } from 'antd'
import { ArrowLeftToLine, ArrowRightToLine } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { useIconSizes } from 'src/hooks'

import type { ColumnPinSide } from '../types'

import { useStyles } from './styles'

type Props = {
  pinSide: ColumnPinSide | undefined
  isExpanded: boolean
  onPin: (side: ColumnPinSide | undefined) => void
}

const PIN_BUTTONS = [
  { side: 'left', icon: ArrowLeftToLine, labelKey: 'column_settings_pin_left' },
  {
    side: 'right',
    icon: ArrowRightToLine,
    labelKey: 'column_settings_pin_right'
  }
] as const

export const ColumnPinButtons = ({ pinSide, isExpanded, onPin }: Props) => {
  const { t } = useTranslation()
  const { styles, cx } = useStyles()
  const iconSizes = useIconSizes()

  return (
    <Flex align="center">
      {PIN_BUTTONS.filter(({ side }) => isExpanded || side === pinSide).map(
        ({ side, icon: Icon, labelKey }) => {
          const isPinned = pinSide === side
          const label = isPinned ? t('column_settings_unpin') : t(labelKey)

          return (
            <Tooltip key={side} title={label} mouseEnterDelay={0.4}>
              <Button
                type="text"
                size="small"
                aria-label={label}
                aria-pressed={isPinned}
                icon={<Icon size={iconSizes.small} />}
                className={cx(styles.pin, isPinned && styles.pinned)}
                onClick={(event) => {
                  event.stopPropagation()
                  onPin(isPinned ? undefined : side)
                }}
              />
            </Tooltip>
          )
        }
      )}
    </Flex>
  )
}
